module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("byRhI"))).then(() => parcelRequire('5erN3'));